import React from "react";

const CustomLabel = ({ x, y, width, height, value, index, data }) => {
    return (
        <text
            x={x + width / 2}
            y={height > 0 ? y - 10 : y - 10 + height}
            fill="black"
            textAnchor="middle"
            fontSize={14}
            className="font-bold"
        >
            {data[index].name === "Final" || data[index].name === "Existing"
                ? Math.round(value).toLocaleString()
                : Math.round(data[index].CARR).toLocaleString()}
        </text>
    );
};

export default CustomLabel;
